import React from "react";
import _ from "lodash";
// localization
import { useLocalizedName } from "../../globals/langHelpers";

// Material UI
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";

// admin layout components
import { Caption, Value } from "./workOrderDetails";
import SubdirectoryArrowRightIcon from "@material-ui/icons/SubdirectoryArrowRight";
import { defineMessage, useIntl } from "react-intl";
import { safeParse } from "../../utils/safeParse";
import { questionTypes } from "../activityQuestions/utils/questionTypes";

export const activityQuestionStyles = makeStyles((theme) => ({
    activityQuestion: {
        paddingRight: "6px",
    },
}));

const getValue = (question, value, getLocalizedName, language) => {
    const metadata = question.metadata ? safeParse(question.metadata || "") : null;
    if (question.controlType === questionTypes.dropdown && question.metadata) {
        const ddValue = metadata?.allowedValues.find((val) => val.id === value);
        return getLocalizedName({ object: ddValue });
    } else if (question.controlType === questionTypes.checkbox && question.metadata) {
        let dbkey = "name_" + language;
        const chkvalues = !!value ? metadata?.allowedValues.filter((val) => value.includes(val.id)) : null;
        let checkboxValue = _.map(chkvalues, _.iteratee(dbkey));
        return checkboxValue.join();
    } else {
        return value;
    }
};

const ActivityQuestion = ({ question, value, language, activityQuestionComment, xs = 3 }) => {
    const { getLocalizedName } = useLocalizedName();
    const questionValue = getValue(question, value, getLocalizedName, language);
    const intl = useIntl();
    const messages = defineMessage({
        comment: {
            id: "admin.work-order-details.comment",
            defaultMessage: "Comment",
            description: "Comment",
        },
        reason: {
            id: "admin.work-order-details.reason",
            defaultMessage: "Reason",
            description: "Reason",
        },
    });

    const questionLabelsAndValues = {
        "Is work site accessible by vehicles?": {
            // Question name
            name: "comment",
            // Question label
            label: intl.formatMessage(messages.comment),

            value: safeParse(activityQuestionComment)?.comment_Vehicles,
        },
        "Is a tech required onsite for the dig?": {
            name: "reason",
            label: intl.formatMessage(messages.reason),
            value: safeParse(activityQuestionComment)?.reason_Dig,
        },
    };
    const questionIsAllowedForAdditionalInfo = (questionFieldName) => {
        const allowedFieldNames = ["Is work site accessible by vehicles?", "Is a tech required onsite for the dig?"];

        return allowedFieldNames.includes(questionFieldName);
    };
    return (
        <>
            <Caption>{getLocalizedName({ object: question }).replace(/\s+/g, " ")}</Caption>
            <Value>{questionValue}</Value>
            {questionIsAllowedForAdditionalInfo(question?.nameEn) && (
                <Grid container>
                    <Typography variant="body1" style={{ display: "flex" }}>
                        <SubdirectoryArrowRightIcon fontSize="small" />
                        {questionLabelsAndValues[question?.nameEn]?.label}:
                    </Typography>
                    <Grid item xs={12} style={{ paddingLeft: "1.3rem" }}>
                        <Value>{questionLabelsAndValues[question?.nameEn]?.value}</Value>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default ActivityQuestion;
